// @flow
import React, { PureComponent } from 'react';

import type { TeamList } from 'types/TeamList';
import LazyLoad from 'components/fragments/LazyLoad';
import TeamMenuNextMatch from 'containers/teammenu/TeamMenuNextMatchContainer';
import TeamMenuLastResult from 'components/teammenu/TeamMenuLastResult';
import TeamMenuNews from 'components/teammenu/TeamMenuNews';
import TeamMenuPOTM from 'components/teammenu/TeamMenuPOTM';
import TeamMenuStore from 'components/teammenu/TeamMenuStore';
import TeamMenuDropdownMenu from 'components/teammenu/TeamMenuDropdownMenu';
import CardBoutique from 'containers/fragments/CardBoutiqueContainer';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';

export type StateProps = {
  status: string,
  isHome: boolean,
  boutique: {
    link: string,
    title: string,
    image: string,
    description: string,
    cta: string,
    team_home: boolean,
    banner_only: boolean,
  },
  teamlist: TeamList[],
};

export type DispatchProps = {
  fetchTeamList: () => void,
};

type Props = StateProps & DispatchProps;

type State = {
  activeTeam: Object,
  loading: boolean
};

class TeamMenu extends PureComponent<Props, State> {

  constructor() {
    super();
    this.teamChange = this.teamChangeAction.bind(this);
  }

  state: State = {
    activeTeam: {},
    loading: false,
  };

  teamChange: Function;

  componentDidMount() {
    this.props.fetchTeamList();
  }

  teamChangeAction(team: Object) {
    this.setState({activeTeam: {}, loading: true}, () => this.setState({activeTeam: team, loading: false}));
  }

  _isnextmatch = (selectedTeam: Object) => {
    if (selectedTeam != null && Object.getOwnPropertyNames(selectedTeam).length !== 0) {
      if (selectedTeam.prochaine_rencontre.adversaire) {
        return (<TeamMenuNextMatch datas={selectedTeam}/>);
      } else if (selectedTeam.bloc_prochaine_rencontre && selectedTeam.bloc_prochaine_rencontre.tagName) {
        return(
          <div className="mb-2">
            <ContentBloc {...selectedTeam.bloc_prochaine_rencontre} />
          </div>
        );
      }
    }

    return null;
  }

  _isDatas = (selectedTeam: Object) => {
    const returnValue = [];
    const { loading } = this.state;
    if (selectedTeam && Object.getOwnPropertyNames(selectedTeam).length !== 0) {
      if (selectedTeam.dernieres_rencontres !== null && selectedTeam.dernieres_rencontres.length !== 0) {
        if (selectedTeam.dernieres_rencontres[0]) {
          returnValue.push(<TeamMenuLastResult datas={selectedTeam} key={'teamMenuLastResult'}/>);
        }
      } else if (selectedTeam.bloc_results_past && selectedTeam.bloc_results_past.tagName) {
        returnValue.push(
          <div key={'teamMenuLastResult'} className="col col-md-12 col-lg-5 mb-2 mb-lg-0">
            <ContentBloc {...selectedTeam.bloc_results_past} />
          </div>
        );
      }

      if (selectedTeam.joueur_du_mois && Object.getOwnPropertyNames(selectedTeam.joueur_du_mois).length !== 0) {
        if (selectedTeam.joueur_du_mois.nom) {
          returnValue.push(<TeamMenuPOTM datas={selectedTeam} key={'teamMenuPOTM'} loading={loading} />);
        }
      }

      if (!selectedTeam.joueur_du_mois &&
        selectedTeam.boutique && Object.getOwnPropertyNames(selectedTeam.boutique).length !== 0) {
        if (selectedTeam.boutique.nom) {
          returnValue.push(<TeamMenuStore datas={selectedTeam} key={'teamMenuStore'}/>);
        }
      }
      if (selectedTeam.news &&
        selectedTeam.news.length > 0) {
          returnValue.push(
            <TeamMenuNews news={selectedTeam.news} newsCat={selectedTeam.news_cat} key={'teamMenuNews'}/>
          );
      }
    }
    return returnValue;
  }

  render() {
    const { boutique } = this.props;
    const defaultTeam = this.props.teamlist.filter((team) => {
      return  team.defaut_home === true;
    });

    let allTeams = this.props.teamlist;
    if (this.props.isHome && allTeams) {
      allTeams = this.props.teamlist.filter((team) => {
        return team.home === true;
      });
    }
    const selectedTeam = this.state.activeTeam.title
      ? this.state.activeTeam
      : (defaultTeam[0] ? defaultTeam[0] : this.props.teamlist[0]);
    if (this.props.teamlist) {
      return (
        <section className="container section">
          <a
            href={selectedTeam && selectedTeam.link}
            className="link-chevron link-chevron--right section__link section__link--zIndex mt-1"
            data-label="">
              <span>{"Voir toutes les informations de l'équipe"}</span>
              <i className="icon icon-chevron-right"></i>
          </a>
          <LazyLoad>
            <TeamMenuDropdownMenu
              hiddenMenuElements={allTeams}
              isMobile={false}
              id={6}
              activeTeam={selectedTeam}
              switchTeam={this.teamChange.bind(this)} />
            
            {boutique.team_home && 
              <div className="row mb-2">
                <CardBoutique />
              </div>}
            {this._isnextmatch(selectedTeam)}

            <div className="row">
              {this._isDatas(selectedTeam)}
            </div>

            <a href={selectedTeam && selectedTeam.link} className="link-chevron mt-4 section__link" data-label="">
              <span>{"Voir toutes les informations de l'équipe"}</span>
              <i className="icon icon-chevron-right"></i>
            </a>
          </LazyLoad>
        </section>
      );
    }

    return null;
  }

};

export default TeamMenu;
